(function(){
'use strict';
if (window.__saettoIx) return; window.__saettoIx = 1;
var reduced = false; try { reduced = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}
if (reduced || (window.Shopify && Shopify.designMode)) return;
var FINE = false; try { FINE = matchMedia('(pointer: fine)').matches; } catch(e){}
var VIO = '124,77,255';
function on(el,ev,fn,op){ el.addEventListener(ev,fn,op||false); }
function css(txt){ var s=document.createElement('style'); s.textContent=txt; document.head.appendChild(s); }
try {
css('.sx-energy{transition:transform .18s ease,box-shadow .25s ease}'+
'.sx-energy:hover{box-shadow:0 0 0 1px rgba('+VIO+',.55),0 0 26px rgba('+VIO+',.30)}'+
'.sx-energy .sx-sheen{position:absolute;top:0;bottom:0;width:46%;left:-60%;background:linear-gradient(105deg,transparent 0%,rgba(255,255,255,.28) 50%,transparent 100%);pointer-events:none;transform:skewX(-12deg)}'+
'.sx-energy:hover .sx-sheen{animation:sxSheen .7s ease forwards}'+
'@keyframes sxSheen{to{left:118%}}'+
'.sx-tilt{transform-style:preserve-3d;will-change:transform;transition:transform .32s cubic-bezier(.2,.8,.3,1),box-shadow .32s ease}'+
'.sx-tilt.sx-live{transition:box-shadow .32s ease}'+
'.sx-tilt:hover{box-shadow:0 18px 44px rgba(6,6,14,.45),0 0 0 1px rgba('+VIO+',.28)}'+
'.sx-glare{position:absolute;inset:-20%;background:radial-gradient(circle at 50% 50%,rgba(255,255,255,.16) 0%,rgba(255,255,255,.05) 26%,transparent 55%);opacity:0;transition:opacity .3s ease;pointer-events:none;z-index:3;mix-blend-mode:screen}'+
'.sx-tilt:hover .sx-glare{opacity:1}'+
'.sx-lens{position:fixed;width:190px;height:190px;border-radius:50%;pointer-events:none;z-index:9998;display:none;background-repeat:no-repeat;box-shadow:0 0 0 2px rgba('+VIO+',.65),0 0 30px rgba('+VIO+',.35),inset 0 0 18px rgba(6,6,14,.35)}'+
'.sx-ripple{position:absolute;border-radius:50%;border:2px solid rgba('+VIO+',.8);pointer-events:none;z-index:5;animation:sxRip .55s ease-out forwards}'+
'@keyframes sxRip{from{opacity:.9;transform:translate(-50%,-50%) scale(.2)}to{opacity:0;transform:translate(-50%,-50%) scale(2.4)}}'+
'.sx-spark{position:fixed;width:5px;height:5px;border-radius:50%;pointer-events:none;z-index:9999}'+
'.sx-nl-canvas{position:absolute;inset:0;z-index:0;pointer-events:none}');
// ---------- 1. ENERGY BUTTONS ----------
var btns = document.querySelectorAll('.button, .saetto-pp__btn, .sticky-add-to-cart__bar button');
for (var i=0;i<btns.length;i++){ (function(b){
  if(b.classList.contains('sx-energy')) return;
  if(b.closest && b.closest('media-gallery, .product-media, slideshow-component, .product-media-container')) return;
  b.classList.add('sx-energy');
  var cs0=getComputedStyle(b); if(cs0.position==='static'){ b.style.position='relative'; } b.style.overflow='hidden';
  var sh=document.createElement('span'); sh.className='sx-sheen'; sh.setAttribute('aria-hidden','true'); b.appendChild(sh);
  if(FINE){
    on(b,'mousemove',function(e){ var r=b.getBoundingClientRect();
      var dx=(e.clientX-r.left-r.width/2)/r.width, dy=(e.clientY-r.top-r.height/2)/r.height;
      b.style.transform='translate('+(dx*7).toFixed(1)+'px,'+(dy*5).toFixed(1)+'px)'; });
    on(b,'mouseleave',function(){ b.style.transform=''; });
  }
})(btns[i]); }
// ---------- 2. LENS-TILT CARDS ----------
if(FINE){
  var cards = document.querySelectorAll('.collection-card, product-card.product-card');
  for (var c=0;c<cards.length;c++){ (function(card){
    card.classList.add('sx-tilt');
    var host = card.querySelector('.collection-card__inner') || card;
    if(getComputedStyle(host).position==='static') host.style.position='relative';
    var gl=document.createElement('div'); gl.className='sx-glare'; gl.setAttribute('aria-hidden','true'); host.appendChild(gl);
    var raf=0;
    on(card,'mousemove',function(e){ if(raf) return; raf=requestAnimationFrame(function(){ raf=0;
      var r=card.getBoundingClientRect();
      var px=(e.clientX-r.left)/r.width, py=(e.clientY-r.top)/r.height;
      var rx=((py-0.5)*-7).toFixed(2), ry=((px-0.5)*9).toFixed(2);
      card.classList.add('sx-live');
      card.style.transform='perspective(900px) rotateX('+rx+'deg) rotateY('+ry+'deg) scale(1.015)';
      gl.style.background='radial-gradient(circle at '+(px*100).toFixed(1)+'% '+(py*100).toFixed(1)+'%,rgba(255,255,255,.18) 0%,rgba(255,255,255,.05) 26%,transparent 55%)';
    }); });
    on(card,'mouseleave',function(){ card.classList.remove('sx-live'); card.style.transform=''; });
  })(cards[c]); }
}
// ---------- 3. MARQUEE VELOCITY SKEW ----------
var mq = document.querySelector('marquee-component .marquee__wrapper');
if(mq){
  var vel=0, target=0, lastY=null, mqRaf=0;
  var scroller = document;
  on(scroller,'scroll',function(){ var y = -((document.querySelector('.saetto-hero')||document.body).getBoundingClientRect().top);
    if(lastY!=null){ target = Math.max(-10, Math.min(10, (y-lastY)*0.25 )); } lastY = y; kickMq(); }, {capture:true, passive:true});
  function kickMq(){ if(mqRaf) return; mqRaf=requestAnimationFrame(stepMq); }
  function stepMq(){ mqRaf=0; vel += (target-vel)*0.12; target*=0.86;
    if(Math.abs(vel)>0.02||Math.abs(target)>0.02){ mq.style.transform='skewX('+(-vel).toFixed(2)+'deg)'; kickMq(); }
    else if(mq.style.transform){ mq.style.transform=''; } }
}
// ---------- 4. MAGNET LINES (newsletter) ----------
var nl = null; var secs = document.querySelectorAll('.shopify-section');
for (var s=0;s<secs.length;s++){ if(secs[s].textContent.indexOf('Stay in the light')>-1){ nl=secs[s]; break; } }
if(nl){
  var wrap = nl.querySelector('.custom-section-content') || nl;
  if(getComputedStyle(wrap).position==='static') wrap.style.position='relative';
  var mc = document.createElement('canvas'); mc.className='sx-nl-canvas'; mc.setAttribute('aria-hidden','true');
  wrap.insertBefore(mc, wrap.firstChild);
  var mctx = mc.getContext('2d');
  var mw=0, mh=0, cols=0, rows=0, cell=64, angs=null, tgts=null;
  var mx=-9999, my=-9999, mVis=false, mRaf=0, mT=0;
  function mResize(){ var r=wrap.getBoundingClientRect(); mw=Math.round(r.width); mh=Math.round(r.height);
    var d=Math.min(devicePixelRatio||1,1.5); mc.width=mw*d; mc.height=mh*d; mc.style.width=mw+'px'; mc.style.height=mh+'px'; mctx.setTransform(d,0,0,d,0,0);
    cols=Math.ceil(mw/cell); rows=Math.ceil(mh/cell);
    angs=new Float32Array(cols*rows); tgts=new Float32Array(cols*rows);
    for(var a2=0;a2<angs.length;a2++){ angs[a2]=Math.random()*6.28; } }
  mResize();
  if(FINE){ on(nl,'mousemove',function(e){ var r=wrap.getBoundingClientRect(); mx=e.clientX-r.left; my=e.clientY-r.top; }); on(nl,'mouseleave',function(){ mx=-9999; }); }
  function mStep(ts){ mRaf=0; if(!mVis) return; mT=ts/1000;
    mctx.clearRect(0,0,mw,mh);
    var half=9;
    for(var gy=0;gy<rows;gy++){ for(var gx=0;gx<cols;gx++){
      var cx=gx*cell+cell/2, cy=gy*cell+cell/2, idx=gy*cols+gx;
      var ta;
      if(mx>-999){ ta=Math.atan2(my-cy,mx-cx); }
      else { ta=Math.sin(mT*0.5 + gx*0.35 + gy*0.5)*0.9 + 0.6; }
      var d0=angs[idx]; var diff=Math.atan2(Math.sin(ta-d0),Math.cos(ta-d0));
      angs[idx]=d0+diff*0.10;
      var dx=Math.cos(angs[idx])*half, dy=Math.sin(angs[idx])*half;
      var dist = mx>-999 ? Math.hypot(mx-cx,my-cy) : 9999;
      var glow = dist<180 ? (1-dist/180) : 0;
      mctx.strokeStyle='rgba('+VIO+','+(0.16+glow*0.5)+')';
      mctx.lineWidth=1.1;
      mctx.beginPath(); mctx.moveTo(cx-dx,cy-dy); mctx.lineTo(cx+dx,cy+dy); mctx.stroke();
      mctx.fillStyle='rgba(200,180,255,'+(0.20+glow*0.7)+')';
      mctx.beginPath(); mctx.arc(cx+dx,cy+dy,1.4+glow*1.4,0,6.28); mctx.fill();
    } }
    mRaf=requestAnimationFrame(mStep);
  }
  var mio = new IntersectionObserver(function(es){ for(var e3=0;e3<es.length;e3++){ mVis=es[e3].isIntersecting; }
    if(mVis && !mRaf) mRaf=requestAnimationFrame(mStep); },{rootMargin:'80px'});
  mio.observe(nl);
  on(window,'resize',function(){ clearTimeout(window.__sxNlT); window.__sxNlT=setTimeout(mResize,200); });
  setTimeout(function(){ if(!mVis){ var r=nl.getBoundingClientRect(); if(r.bottom>-80&&r.top<innerHeight+80){ mVis=true; if(!mRaf) mRaf=requestAnimationFrame(mStep); } } },1500);
}
// ---------- 5. PDP LENS ZOOM ----------
if(FINE && document.querySelector('media-gallery')){
  var lens = document.createElement('div'); lens.className='sx-lens'; lens.setAttribute('aria-hidden','true'); document.body.appendChild(lens);
  var dragging=false;
  on(document,'pointerdown',function(){ dragging=true; lens.style.display='none'; },true);
  on(document,'pointerup',function(){ dragging=false; },true);
  var medias = document.querySelectorAll('.product-media');
  for(var m2=0;m2<medias.length;m2++){ (function(pm){
    var img = pm.querySelector('img'); if(!img) return;
    on(pm,'mousemove',function(e){ if(dragging){ lens.style.display='none'; return; }
      var r=pm.getBoundingClientRect(); var Z=2.1;
      lens.style.display='block';
      lens.style.left=(e.clientX-95)+'px'; lens.style.top=(e.clientY-95)+'px';
      lens.style.backgroundImage='url("'+(img.currentSrc||img.src)+'")';
      lens.style.backgroundSize=(r.width*Z)+'px '+(r.height*Z)+'px';
      lens.style.backgroundPosition=(-((e.clientX-r.left)*Z-95))+'px '+(-((e.clientY-r.top)*Z-95))+'px';
    });
    on(pm,'mouseleave',function(){ lens.style.display='none'; });
  })(medias[m2]); }
}
// ---------- 6. SWATCH RIPPLE ----------
on(document,'click',function(e){
  var lb = e.target.closest ? e.target.closest('.variant-option__button-label, .variant-option__swatch, label[class*="swatch"]') : null;
  if(!lb) return;
  if(getComputedStyle(lb).position==='static') lb.style.position='relative';
  var r=lb.getBoundingClientRect();
  var rp=document.createElement('span'); rp.className='sx-ripple';
  var sz=Math.max(r.width,r.height);
  rp.style.width=sz+'px'; rp.style.height=sz+'px';
  rp.style.left=(e.clientX-r.left)+'px'; rp.style.top=(e.clientY-r.top)+'px';
  lb.appendChild(rp); setTimeout(function(){ rp.remove(); },600);
},true);
// ---------- 7. ATC PARTICLE BURST ----------
function burst(el){
  var r=el.getBoundingClientRect(); var cx=r.left+r.width/2, cy=r.top+r.height/2;
  for(var b2=0;b2<26;b2++){
    var sp=document.createElement('span'); sp.className='sx-spark';
    var hue = Math.random()<0.6;
    sp.style.background = hue ? 'rgb('+VIO+')' : '#EDE8FF';
    sp.style.left=cx+'px'; sp.style.top=cy+'px';
    document.body.appendChild(sp);
    var an=Math.random()*6.283, dist=40+Math.random()*90, dur=520+Math.random()*380;
    sp.animate([
      {transform:'translate(0,0) scale(1)', opacity:1},
      {transform:'translate('+(Math.cos(an)*dist).toFixed(0)+'px,'+(Math.sin(an)*dist-24).toFixed(0)+'px) scale(.2)', opacity:0}
    ],{duration:dur, easing:'cubic-bezier(.15,.6,.3,1)'}).onfinish=(function(el2){ return function(){ el2.remove(); }; })(sp);
  }
}
window.__sxBurst = burst;
on(document,'submit',function(e){
  var f=e.target;
  if(f && f.getAttribute && (f.getAttribute('action')||'').indexOf('/cart/add')>-1){
    var bt=f.querySelector('button[type="submit"], button[name="add"]');
    if(bt) burst(bt);
  }
},true);
} catch(err){ window.__sxErr = String(err && err.message) + '|' + String(err && err.stack).slice(0,300); }
})();
